/* eslint-disable react/jsx-key */
/* react-table provides the key */

import classnames from "classnames";
import { FC, CSSProperties, MouseEventHandler } from "react";
import { ColumnInstance } from "react-table";
import { useTableContext } from "./context";

const stopPropagation: MouseEventHandler<HTMLElement> = (e) => e.stopPropagation();

export const Table: FC = () => {
  const { table } = useTableContext();

  return (
    <table {...table!.getTableProps()} className="table table-striped">
      <thead className="border-bottom-2 border-light">
        {table!.headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th className="fw-bold" {...column.getHeaderProps({
                ...(column.getSortByToggleProps?.() || {}),
                ...{ style: getThStyle(column) },
              })}>
                <div className="mb-2">
                  {column.render("Header")}
                  {column.isSorted && (
                    <span className={classnames("bi mx-2", {
                      "bi-sort-down": column.isSortedDesc,
                      "bi-sort-up": !column.isSortedDesc,
                    })} />
                  )}
                </div>
                <div onClick={stopPropagation}>{column.canFilter && (
                  column.render("Filter")
                )}</div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...table!.getTableBodyProps()} className="border-0">
        {(table!.page || table!.rows).map((row) => {
          table!.prepareRow(row);
          return (
            <tr {...row.getRowProps()} className="border-top border-light">
              {row.cells.map((cell) => (
                <td {...cell.getCellProps({ style: getTdStyle(cell.column) })}>
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table >
  );
};


function getThStyle(column: ColumnInstance): CSSProperties {
  return {
    ...getColumnWidthStyle(column),
    verticalAlign: "top",
  };
}

function getTdStyle(column: ColumnInstance): CSSProperties {
  return {
    ...getColumnWidthStyle(column),
  };
}

function getColumnWidthStyle(column: ColumnInstance): CSSProperties {
  const { minWidth, maxWidth, width } = column;
  return {
    minWidth,
    maxWidth,
    width,
  };
}
